import { render, staticRenderFns } from "./InstitutionEditForm.vue?vue&type=template&id=22899fff"
import script from "./InstitutionEditForm.vue?vue&type=script&lang=js"
export * from "./InstitutionEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports